import { nodeRedApi } from '../../services/axios';

export async function getAlarmes() {
  try {
    const { data } = await nodeRedApi.get('/getAlarmes');
    return data;
  } catch (error) {
    console.error("Erro ao buscar alarmes:", error);
    return [];
  }
}
